import type { Channel, OrganisationAgent } from '../api/types'

/** What the organisation stream counts as unread: every room's, and your agents' private messages. */
export function unreadTotal(channels: Channel[], agents: OrganisationAgent[]): number {
  return channels.reduce((sum, channel) => sum + channel.unread, 0)
    + agents.reduce((sum, agent) => sum + agent.direct_unread, 0)
}

/** How many places hold something unread, each agent's direct message being one. */
export function unreadPlaces(channels: Channel[], agents: OrganisationAgent[]): number {
  return channels.filter((channel) => channel.unread > 0).length
    + agents.filter((agent) => agent.direct_unread > 0).length
}
